// extracted by mini-css-extract-plugin
export default {"header":"Header_header__FoQbW","logo":"Header_logo__a+HFC","user":"Header_user__YR3I7","menu":"Header_menu__s2zbG"};